/**
 * Normalize store names to title case with preserved spaces
 * @param store - The store name to normalize
 * @returns Normalized store name in title case (e.g., "whole foods" -> "Whole Foods")
 */
export const normalizeStoreName = (store: string | undefined): string => {
  if (!store) return 'N/A';
  return store
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
